import React from 'react';

export default function EmptyState({ message }) {
  return (
    <div className="text-center py-4 text-muted">
      <p className="mb-0 small">{message || 'No hay datos para mostrar.'}</p>
    </div>
  );
}
